import { Component, OnInit, AfterViewInit, AfterViewChecked, ElementRef, Inject, ViewChild, NgZone, Renderer2, HostListener, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { API, CONST_AWS_API } from '../../../../../core/constants'
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'src/app/core/services/storage.service';
import { LandingPageService } from './../../../../../core/services/landing-page.service';
import { ConfirmationDialogComponent } from '../../../confirmation-dialog/confirmation-dialog.component';
import { DomSanitizer } from '@angular/platform-browser';
import { COLORLIST } from './../../../../../core/constants';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroupDirective, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ValidationService } from 'src/app/core/services/validation.service';
import { AppService } from 'src/app/core/services/app.service';
import { UserService } from 'src/app/core/services/user.service';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { EventCheckoutDialog } from '../event-tickets/event-tickets.component';
import { EventQuickRegisterService } from 'src/app/core/services/event-quick-register.service';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
declare let $: any;
declare var fbq: any;

// GET_EVENT_BY_SLUG runs the shared loader under its own task id: other components (e.g. the
// header) call stop() on the default task while this request is still in flight, which used to
// hide the loader and leave the content area blank.
const EVENT_LOADER_TASK = 'event-details-load';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss'],
  host: {
    '(document:click)': 'outsideClick($event)',
  },
  encapsulation: ViewEncapsulation.None,
})
export class EventDetailsComponent implements OnInit, AfterViewInit, AfterViewChecked {

  @ViewChild('toggleButton', { static: false }) toggleButton: ElementRef;
  @ViewChild('menu', { static: false }) menu: ElementRef;
  @ViewChild('video_frame', { static: false }) videoplayer: ElementRef;
  @ViewChild('ticketOverdiv', { static: false }) ticketOverdivRef: ElementRef<HTMLElement>;
  @ViewChild('partyTicketPanel', { static: false }) partyTicketPanelRef: ElementRef<HTMLElement>;
  ticketPanelOverflowPx = 0;
  private ticketPanelResizeObserver: ResizeObserver;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  isShown: boolean = false;
  streamInfo: any = {};
  private eventRequestKey: string = null;
  private lastLoadedEventKey: string = null;
  checkSale: boolean = false;
  startDate: any;
  nextDate: any;
  saleStarts: boolean = false;
  saleCompleted: boolean;
  displayAmounts: any;
  eventType: any;
  currentLocation: any;
  currencyType: string;
  isUserRegistered = false;
  isRemindMeBusy = false;
  streamDescription: any;
  userId: any;
  ticketsData: any;
  checkIsUserSubscribed: any;
  guestList: any;
  timezone: any;
  performer_info: any;
  userColor: any = {};
  countUserColor = 0;
  displayName: any;
  sponsorsInfo: any;
  datesList: any = [];
  subEvents: any = [];
  selectedDate: any;
  selectedTabEvent: any;
  selectedDateIndex: any;
  selectedTabData: number;
  agendaGuestsData: any = [];
  priceDetails: any;
  getCurrency: any;
  userSubscriptionInfo: any;
  expoInfo: any;
  disPlayText: string;
  disPlayTextMulti: string;
  contactInformtionForm: FormGroup;
  imInterestedClick: boolean;
  isBannerVideo: boolean;
  videoId: any;
  settingsJSON: any;
  streamAdsData: any;
  sponsorData: any;
  preloadAdsdata: any[];
  adVideo: any;
  allAds: any;
  eventHomeAdsTop: any[];
  streamAds: any;
  streamAdsDataRight: any[];
  streamAdsDataTop: any[];
  streamAdsDataTopId: any[];
  streamAdsDataRightId: any[];
  eventHomeAdsRight: any[];
  streamingPageAdsRight: any[];
  streamingeventHomeAdsTop: any[];
  streamingPageAdsTop: any;
  duration: any;
  myList: { image: string; time: string; }[];
  adsImage: any;
  currencyInfoSubscription: Subscription;
  showVideoIcon: boolean = false
  clientDetails: any;
  assets_url = environment.assets_url;
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  finalGuestsList: any = [];
  addOnCheck: boolean = false;
  showHome: boolean;
  catName: any;
  device: any;
  timezoneVal: any;
  settingsDataSubscription: Subscription;
  settingsData: any = {};
  showError: boolean = false;
  private unsubscriber: Subject<void> = new Subject<void>();
  @ViewChild('widgetsContent', { static: false }) widgetsContent: ElementRef;
  nftPriceDetails: any;
  cryptoSymbol: string;
  cryptoToken: string;
  USD_Rates: any;
  boxShadow!: string;

  constructor(public router: Router, private location: Location,
    private ngxLoader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    public route: ActivatedRoute,
    private toastr: ToastrService,
    private storageService: StorageService,
    private landingPageService: LandingPageService,
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private myElement: ElementRef,
    private formBuilder: FormBuilder,
    private appService: AppService,
    private zone: NgZone,
    private renderer: Renderer2,

    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private quickRegister: EventQuickRegisterService
  ) {
    this.renderer.listen('window', 'click', (e: Event) => {
      if (this.toggleButton && this.toggleButton.nativeElement && this.menu && this.menu.nativeElement) {
        if (e.target !== this.toggleButton.nativeElement && e.target !== this.menu.nativeElement) {
          // this.isShown = false;
        }
      }
    });
  }



  ngOnInit() {
    // setTimeout(() => {
    //   // this.loadAdsScript();
    // }, 1000);
    let deviceInfo = this.commonSubscribeService.getMobileOperatingSystem();
    this.cryptoSymbol = environment.clientDetails.crypto_symbol;
    this.cryptoToken = environment.clientDetails.crypto_token;
    this.timezoneVal = this.userService.getTimezone();
    if (!this.router.url.includes('/event/home/')) {
      this.storageService.deleteItem('ticket_key');
    }
    this.clientDetails = environment.clientDetails;
    this.commonSubscribeService.sendScreenStatus(true);
    this.buildcontactInformtionForm();
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
    });
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        this.getEventDetails();
      }
    });
    this.getCurrency = this.storageService.getItem('currency');
    this.device = this.commonSubscribeService.getMobileOperatingSystem();
    if (this.device == 'android' || this.device == 'ios')
      document.getElementById('eventDetails').scrollIntoView({ behavior: 'smooth' });
    // this.eventType = this.storageService.getItem('isEvent');
    this.userId = typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id);
    // this.userId = !this.userInfo.is_guest ? this.userId : '';
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
        } else {
          this.currentLocation = json;
        }
        this.getEventDetails();
      });
    }
    if (this.currentLocation && Object.keys(this.currentLocation).length > 0)
      this.getEventDetails();
    console.log('>>>>>>>>>>', this.showHome)
    console.log(this.route);
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    // Apply the CSS vars for this synchronous snapshot immediately - icWebpageSettingsSubject
    // (below) is a plain Subject, not a BehaviorSubject, so it does NOT replay its last emission
    // to a new subscriber. By the time this component mounts, the route guard's theme fetch for
    // THIS navigation has already completed and already called .next() once - if that happened
    // before this subscribe() call below (the normal case for both group and network routes),
    // this component would otherwise miss it entirely and keep whatever --event-border-color/
    // --event-font-primary-color were last left at by the previous page (e.g. still showing a
    // previous group's colors after navigating from the AI agent's event cards).
    this.applyThemeCssVars();
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
      this.settingsData = response;
      this.applyThemeCssVars();
      const rgb = this.hexToRgb(this.settingsData.tertiaryBgFontColor3);
      this.boxShadow = `0 0 17px 0 rgba(${rgb}, 0.69)`;
      // if (!this.settingsData.is_preview) {
      //   this.getStreamInfo();
      // } else if (this.activatedRoute.snapshot.queryParams.token && this.router.url.includes('preview')) {
      //   this.getAlbumInfo();
      // } else {
      //   this.getStreamInfo();
      // }
    });

  }

  
  hexToRgb(hex: string): string {
    const bigint = parseInt(hex.replace('#', ''), 16);
    return `${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255}`;
  }

  getTabStyles(index: any) {
    if (!this.settingsData) return {};
    return {
      'background-color': this.selectedDateIndex == index ? this.settingsData['event_button_bg_primary_color'] : 'transparent',
      'color': this.settingsData[this.selectedDateIndex == index ? 'event_button_font_primary_color' : 'event_card_font_color'],
    };
  }

  getBorderColor() {
    if (!this.settingsData) return 'transparent';
    return this.settingsData['event_border_color'] || 'rgba(0, 0, 0, 0.12)'; // Fallback color
  }

  repeatPopup() {
    let data = {
      "userInfo": this.userInfo,
    }
    const dialogRef = this.dialog.open(EventCheckoutDialog, {
      panelClass: 'event-checkout-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
  outsideClick(event) {
    if (event.target.outerText != "Share Event" && event.target.id != "shareEventIcon") {
      // this.isShown = false;
    }
  }

  playVideo(type?) {
    const media = this.videoplayer.nativeElement;
    media.muted = true; // without this line it's not working although I have "muted" in HTML
    // if (!type)
    media.play();
    // else
    //   media.pause();
  }

  onClickPlayButton() {
    this.showVideoIcon = !this.showVideoIcon
    this.isBannerVideo = !this.isBannerVideo
    this.showBlocks('init');
    if (this.streamInfo.is_banner_video_autoplay == 0 && this.showVideoIcon == false) {
      this.showVideoIcon = !this.showVideoIcon
    }
  }

  YouTubeGetID(url) {
    url = url.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    return (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
  }
  stopVideo() {
    this.player.stopVideo();
  }
  startVideo() {
    if (this.playYouTubeVideo)
      this.loadVideo();
    else
      this.player.playVideo();
  }
  pauseVideo() {
    this.player.pauseVideo();
  }

  tab() {
    // duration of scroll animation
    var scrollDuration = 300;
    // paddles
    var leftPaddle = document.getElementsByClassName('left-paddle');
    var rightPaddle = document.getElementsByClassName('right-paddle');
    // get items dimensions
    var itemsLength = $('.item').length;
    var itemSize = $('.item').outerWidth(true);
    // get some relevant size for the paddle triggering point
    var paddleMargin = 20;

    // get wrapper width
    var getMenuWrapperSize = function () {
      return $('.menu-wrapper').outerWidth();
    }
    var menuWrapperSize = getMenuWrapperSize();
    // the wrapper is responsive
    $(window).on('resize', function () {
      menuWrapperSize = getMenuWrapperSize();
    });
    // size of the visible part of the menu is equal as the wrapper size
    var menuVisibleSize = menuWrapperSize;

    // get total width of all menu items
    var getMenuSize = function () {
      return itemsLength * itemSize;
    };
    var menuSize = getMenuSize();
    // get how much of menu is invisible
    var menuInvisibleSize = menuSize - menuWrapperSize;

    // get how much have we scrolled to the left
    var getMenuPosition = function () {
      return $('.menu').scrollLeft();
    };
    if (menuInvisibleSize <= 0) {
      $(leftPaddle).addClass('hidden');
      $(rightPaddle).addClass('hidden');
    }
    console.log("test", menuInvisibleSize);
    // finally, what happens when we are actually scrolling the menu
    $('.menu').on('scroll', function () {

      // get how much of menu is invisible
      menuInvisibleSize = menuSize - menuWrapperSize;
      // get how much have we scrolled so far
      var menuPosition = getMenuPosition();

      var menuEndOffset = menuInvisibleSize - paddleMargin;

      // show & hide the paddles
      // depending on scroll position
      if (menuInvisibleSize <= 0) {
        $(leftPaddle).addClass('hidden');
        $(rightPaddle).addClass('hidden');
      }
      else if (menuPosition <= paddleMargin) {
        $(leftPaddle).addClass('hidden');
        $(rightPaddle).removeClass('hidden');
      } else if (menuPosition < menuEndOffset) {
        // show both paddles in the middle
        $(leftPaddle).removeClass('hidden');
        $(rightPaddle).removeClass('hidden');
      } else if (menuPosition >= menuEndOffset) {
        $(leftPaddle).removeClass('hidden');
        $(rightPaddle).addClass('hidden');
      }
    });
    // scroll to left
    $(rightPaddle).on('click', function () {
      $('.menu').animate({ scrollLeft: menuInvisibleSize }, scrollDuration);
    });
    // scroll to right
    $(leftPaddle).on('click', function () {
      $('.menu').animate({ scrollLeft: '0' }, scrollDuration);
    });

  }
  loadAdsScript() {
    document.querySelectorAll('.videoAds').forEach(vid => (<HTMLVideoElement>vid).pause());
    $('.carousel-inner img').attr('alt', '');
    $('.carousel-inner img').attr('title', '');
    var t;
    var start = $('#myCarousel').find('.active').attr('id');
    t = setTimeout("$('#myCarousel').carousel({interval: 1000});", start - 1000);

    $('#myCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(t);
      var duration1 = $(this).find('.active').attr('id');
      console.log(duration1);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#myCarousel').carousel('pause');
      t = setTimeout("$('#myCarousel').carousel();", duration1 - 1000);
    })

    $('.carousel-control-next').on('click', () => {
      clearTimeout(t);
    });

    $('.carousel-control-prev').on('click', () => {
      clearTimeout(t);
    });



    var r;

    var start = $('#RightCarousel').find('.active').attr('id');
    r = setTimeout("$('#RightCarousel').carousel({interval: 1000});", start - 1000);

    $('#RightCarousel').on('slid.bs.carousel', function (ev) {
      clearTimeout(r);
      var duration2 = $(this).find('.active').attr('id');
      console.log(duration2);
      let slides = $(this).find('.carousel-item');
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if (pvid && (pvid != undefined || pvid != 'undefined')) {
        (<HTMLVideoElement>pvid).pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if (vid && (vid != undefined || vid != 'undefined')) {
        vid.muted = true;
        (<HTMLVideoElement>vid).play();
      }
      $('#RightCarousel').carousel('pause');
      r = setTimeout("$('#RightCarousel').carousel();", duration2 - 1000);
    })

    $('.carousel-control-next').on('click', () => {
      clearTimeout(r);
    });

    $('.carousel-control-prev').on('click', () => {
      clearTimeout(r);
    });
  }


  player;
  playYouTubeVideo = false;
  loadAPI() {
    console.log("id", this.videoId)
    if (window['YT']) {
      // this.loadVideo();
      this.playYouTubeVideo = true;
      return;
    }
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    console.log('API loaded'); // this is shown on the console.
    window['onYouTubeIframeAPIReady'] = () => this.loadVideo();
  }
  loadVideo() {
    this.player = '';
    // (window as any).onYouTubeIframeAPIReady = () => {
    this.player = new window['YT'].Player('player', {
      videoId: this.videoId,
      height: '390',
      width: '100%',
      playerVars: { 'autoplay': 1, 'playsinline': 1 },
      events: {
        'onReady': this.onPlayerReady,
        'onStateChange': (status) => {
          console.log("&&&", status);
          if (status.data == 0) {
            this.zone.run(() => {
              this.showBanner();
            });
          }
        },
      }
    });
    console.log('youtube iframe api ready!', this.player); // this is never triggered.
    // };
  }
  onPlayerReady(event) {
    setTimeout(() => {
      event.target.playVideo();
      event.target.mute();
    }, 100);
  }

  showBanner() {
    if (this.streamInfo.is_banner_video_autoplay == 1) {
      this.isBannerVideo = !this.isBannerVideo;
      this.showBlocks();
    }
    if (this.streamInfo.is_banner_video_autoplay == 0) {
      this.isBannerVideo = !this.isBannerVideo;
      if (this.isBannerVideo == true) {
        this.showBlocks();
      }
      if (this.isBannerVideo == false) {
        this.showBlocks('hide');
      }
    }
  }
  showBlocks(from?) {
    //this.stopVideo();
    $('#video_block').hide();
    $('#youtube_block').hide();
    $('#video_tag').hide();
    $('#banner_block').hide();
    if (this.isBannerVideo) {
      $('#video_block').show();
      if (this.isYoutubeVideo) {
        $('#youtube_block').show();
        if (from == 'init') {
          setTimeout(() => {
            this.startVideo();
          }, 2000);
        } else {
          this.startVideo();
        }
      } else {
        $('#video_tag').show();

        if (from == 'init') {
          setTimeout(() => {
            //$('#video_frame').trigger('play');
            //$('#video_frame').trigger((this.streamInfo.is_banner_video_autoplay == 1) ? 'play':'pause');
            if (this.streamInfo.is_banner_video_autoplay == 1) {
              this.playVideo()
            }

          }, 2000);
        } else {
          //$('#video_frame').trigger('play');
          if (this.streamInfo.is_banner_video_autoplay == 1) {
            this.playVideo()
          }
        }
      }
    }
    else {
      if (this.isYoutubeVideo && this.streamInfo.is_banner_video_autoplay) {
        this.stopVideo();
      }
      if (!this.isYoutubeVideo) {
        $('#video_frame').trigger('pause');
      }
      $('#banner_block').show();
    }
  }



  buildcontactInformtionForm() {
    this.contactInformtionForm = this.formBuilder.group({
      user_first_name: [{ value: this.userInfo.user_first_name, disabled: false }, Validators.required],
      user_last_name: [{ value: this.userInfo.user_last_name, disabled: false }, Validators.required],
      user_email: [{ value: this.userInfo.email, disabled: false }, [Validators.required, ValidationService.emailValidator]],
    });
  }
  saveContactInf() {
    console.log(this.contactInformtionForm);
    console.log("streamifo", this.streamInfo);
    let eventDates = [], eventDate: any;
    if ((this.streamInfo.recurring_type != '' && this.streamInfo.recurring_type != null) && this.streamInfo.selected_type != 'single_session_event') {
      this.datesList.forEach(date => {
        date.eventDatesData = " " + moment(date.startDates).format("DD MMM") + " " + moment(date.startDates).format("YYYY");
        eventDates.push(date.eventDatesData);
      });
    } else if (this.streamInfo.selected_type == 'single_session_event') {
      eventDate = `${this.streamInfo.eventStart} - ${this.streamInfo.eventEnd}`;
    }
    // else if (this.streamInfo.expected_end_date_time != this.streamInfo.publish_date_time && (this.streamInfo.recurring_type == '' || this.streamInfo.recurring_type == null) && this.streamInfo.selected_type != 'single_session_event') {
    //   eventDate = this.streamInfo.publish_date_time + '-' + this.streamInfo.expected_end_date_time;
    // } else if (this.streamInfo.expected_end_date_time == this.streamInfo.publish_date_time && this.streamInfo.selected_type != 'single_session_event') {
    //   eventDate = this.streamInfo.publish_date_time;
    // }
    else if (this.streamInfo.selected_type == 'single_day_event' || this.streamInfo.selected_type == 'multi_day_event') {
      if (this.datesList.length == 1) {
        eventDate = this.eventStartDate;
      } else {
        eventDate = this.eventStartDate + ' - ' + this.eventEndDate;
      }
    }
    let inputData = this.contactInformtionForm.getRawValue();
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "user": {
          "first_name": inputData.user_first_name,
          "last_name": inputData.user_last_name,
          "email": inputData.user_email,
        },
        "stream_info": {
          "id": this.streamInfo.id,
          "stream_video_title": this.streamInfo.stream_video_title,
          "event_date": eventDates.length > 0 ? eventDates : eventDate,
          "video_banner_image": this.streamInfo.video_banner_image,
          "slug": this.route.snapshot.params.slug_name,
        }
      }
    }
    if (this.contactInformtionForm.valid) {
      this.ngxLoader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.INTERESTED, data).then(response => {
        if (response.data.message === "Success") {
          this.ngxLoader.stop();
          this.toastr.success("Event details sent to your email address");
          this.imInterestedClick = false;
          this.contactInformtionForm.reset();
        } else if (response.data.status == 1) {
          this.toastr.error(response.data.message);
        }
      }).catch(error => {
        this.ngxLoader.stop();
      });
    }
  }
  closeForm() {
    this.imInterestedClick = false;
  }
  isYoutubeVideo = false;
  isRegistered = false;
  eventStartDate: any
  eventEndDate: any;
  expDatesArr: any = [];
  showMsg: any;
  description: any = '';
  isLiveTickets: boolean = false;
  tempGuestList: any;
  channelName: any;
  isVodPublished;
  getEventDetails() {
    let ids = this.route.snapshot.params.ticket_key;
    let userId
    if (ids) {
      userId = ids.split('-');
    }
    let id = this.route.snapshot.params.ticket_key ? userId[1] : ''
    let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
    let currentCode = code.includes('\"') ? JSON.parse(code) : code;
    let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "userid": this.userId ? this.userId : id,
        "slug": this.route.snapshot.params.slug_name,
        "offset": new Date().getTimezoneOffset(),
        "currency": localCurrency ? localCurrency : currentCode,
        "timezone": this.timezoneVal
      }
    }
    // getEventDetails() is triggered by init, the location lookup and the currency subscription,
    // often with the same slug/currency/user; an identical request that is in flight or already
    // loaded successfully returns the same data. A currency or login change alters the key.
    const requestKey = JSON.stringify(data.body) + '|' + (this.userInfo.access_token || '');
    if (requestKey === this.eventRequestKey || requestKey === this.lastLoadedEventKey) return;
    this.eventRequestKey = requestKey;
    this.ngxLoader.start(EVENT_LOADER_TASK);
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_BY_SLUG, data).then(response => {
      this.eventRequestKey = null;
      this.ngxLoader.stop(EVENT_LOADER_TASK);
      if (response.data.message === "Success") {
        this.lastLoadedEventKey = requestKey;
        this.channelName = response['data']['Data']['channel_display_name'];
        this.streamInfo = response['data']['Data']['stream_info'];
        // match_info on stream_info itself is the raw (unparsed) DB column string —
        // Data.match_info is the already-parsed convenience copy partner-service writes
        // alongside it (same pattern as stream_source_details/player_type).
        this.streamInfo.match_info = response['data']['Data']['match_info'] || null;
        if ((this.device == 'android' || this.device == 'ios') && this.streamInfo.stream_video_description) {
          this.description = this.streamInfo.stream_video_description.length > 200 ? this.streamInfo.stream_video_description.slice(0, 200) + '...' : '';
        } else if (this.streamInfo.stream_video_description) {
          this.description = this.streamInfo.stream_video_description.length > 600 ? this.streamInfo.stream_video_description.slice(0, 600) + '...' : '';
        }
        this.catName = response['data']['Data']['CategoryName'];
        // if(this.streamInfo.media_files) {
        //   let media_files = JSON.parse(this.streamInfo.media_files);
        //   Object.keys(media_files).forEach(element => {
        //     this.streamInfo[element] = media_files[element];
        //  });
        // }

        this.streamAds = this.streamInfo['stream_ads'];
        this.eventDetails();
        this.settingsJSON = JSON.parse(this.streamInfo.settings_json);
        // this.getSubscriptionList();
        if (this.streamInfo.event_category) {
          if (this.streamInfo.event_category == 'Corporate') {
            this.disPlayText = "Speaker";
            this.disPlayTextMulti = "Speakers";
          } else if (this.streamInfo.event_category == "Entertainment" || this.streamInfo.event_category == "Music") {
            this.disPlayText = "Artist";
            this.disPlayTextMulti = "Artists";
          } else {
            this.disPlayText = "Guest"
            this.disPlayTextMulti = "Guests";
          }
        }
        // this.getExpoList();
        this.commonSubscribeService.sendSlugData(response['data']['Data']);
        this.guestList = response['data']['Data']['guestList'];
        this.priceDetails = response['data']['Data']['price_details'] || {};
        this.nftPriceDetails = response['data']['Data']['nft_price_details']
        this.getMaxPrice();
        let ticketsInfo = response['data']['Data']['tickets'];
        this.isBannerVideo = false;
        if (this.streamInfo.selected_type == "single_session_event") {
          // let localTime = moment.utc(this.streamInfo.publish_date_time).toDate();
          // this.streamInfo.eventStart = moment(localTime).format('ddd') + ", " + moment(localTime).format('DD MMM YYYY, hh:mm A');
          // let endDate = moment.utc(this.streamInfo.expected_end_date_time).toDate();
          // this.streamInfo.eventEnd = moment(endDate).format('hh:mm A');
          let localTime = moment.utc(this.streamInfo.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);

          this.streamInfo.eventStart = localTime.format('ddd') + ", " + localTime.format('DD MMM YYYY, hh:mm A');
          let endDate = moment.utc(this.streamInfo.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          this.streamInfo.eventEnd = endDate.format('hh:mm A');
        }
        let org_past_event = response['data']['Data']['org_past_event'];
        console.log("pas eve &&", org_past_event)
        this.isVodPublished = org_past_event ? org_past_event.split('_')[1] == 1 ? true : false : false;
        console.log("isVodPublished", this.isVodPublished)
        this.isBannerVideo = false;

        if (this.streamInfo.banner_video_url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = this.streamInfo.banner_video_url.match(regExp);
          if (match && match[2].length === 11) {
            // if (this.streamInfo.banner_video_url.includes('https://www.youtube.com')) {
            // this.streamInfo.banner_video_url = this.streamInfo.banner_video_url.replace('watch?v=', 'embed/');
            // console.log();
            this.isYoutubeVideo = true;
            this.videoId = this.YouTubeGetID(this.streamInfo.banner_video_url) //video id
            this.loadAPI();
          } else {
            this.isYoutubeVideo = false;
          }
          if (this.streamInfo.is_banner_video_autoplay == 1) {
            this.isBannerVideo = true;
          }
          if (this.streamInfo.is_banner_video_autoplay == 0) {
            this.isBannerVideo = false;
          }
        }
        this.guestList.forEach(guest => {
          guest.display_name = guest.first_name[0];
          if (guest.last_name) {
            guest.display_name += guest.last_name[0];
          } else if (guest.first_name[1]) {
            guest.display_name += guest.first_name[1];
          }
          guest.userColor = this.getColor(guest);
          guest.shortName = this.getName(guest.display_name);
        });
        this.tempGuestList = this.finalGuestsList = this.guestList.filter(e => e.reveal_to_audience == 1);
        this.performer_info = response['data']['Data']['performer_info'];
        this.sponsorsInfo = response['data']['Data']['sponsers_info'];
        this.groupSponsorsByType();
        let name = ''
        if (this.settingsJSON.produce_by_value) {
          name = this.settingsJSON.produce_by_value.includes(' ') ? this.settingsJSON.produce_by_value.split(' ') : this.settingsJSON.produce_by_value;
        }
        else {
          name = this.performer_info.performer_display_name.includes(' ') ? this.performer_info.performer_display_name.split(' ') : this.performer_info.performer_display_name;
        }
        let secondName = name[1] ? name[1].charAt(0) : name[0].charAt(1);
        this.displayName = name[0].charAt(0) + secondName;
        if (this.streamInfo.publish == 0) {
          this.toastr.info('Event is not published');
          this.ngxLoader.stop();
          this.router.navigateByUrl('/' + this.router.url.split('/')[1]);
          return;
        }
        this.streamInfo.originalPublishDate = this.streamInfo.publish_date_time;
        this.streamInfo.originalExpectedDate = this.streamInfo.expected_end_date_time;
        // publish_date_time/expected_end_date_time come back as bare UTC "YYYY-MM-DD HH:mm:ss"
        // (no timezone marker) - must go through moment.utc(...).tz(...) like the rest of this
        // file (see the "single_session_event" block above) instead of formatting the raw value
        // directly, which showed the wrong calendar date to viewers on the other side of UTC.
        let publishLocalForBanner = moment.utc(this.streamInfo.originalPublishDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
        let expectedEndLocalForBanner = moment.utc(this.streamInfo.originalExpectedDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
        this.streamInfo.publish_date_time = publishLocalForBanner.format("ddd") + ", " + publishLocalForBanner.format("DD MMM") + " " + publishLocalForBanner.format("YYYY");
        this.streamInfo.expected_end_date_time = expectedEndLocalForBanner.format("ddd") + ", " + expectedEndLocalForBanner.format("DD MMM") + " " + expectedEndLocalForBanner.format("YYYY");
        // if (this.streamInfo.stream_payment_mode == 'paid')
        //   this.getTicketsByEventId();
        let subEvents = response['data']['Data']['subEvents'];
        if (subEvents && subEvents.length > 0) {
          const sortByDate = subEvents.sort((a, b) => a.publish_date_time > b.publish_date_time ? 1 : -1);
          this.subEvents = sortByDate;
          this.subEvents.forEach(element => {
            element.finalGuestsList = [];
            if (element.stream_info) {
              // let localTime = moment.utc(element.stream_info.publish_date_time).toDate();
              // let startTime = moment(localTime).format('DD MMM YYYY');
              // let endTime = moment.utc(element.stream_info.expected_end_date_time).toDate();
              // let expEndDate = moment(endTime).format("Y-MM-DD");
              // this.expDatesArr.push(expEndDate);
              // let eventEndTime = moment(endTime).format('DD MMM YYYY');
              let localTime = moment.utc(element.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
              let startTime = localTime.format('DD MMM YYYY');
              let endTime = moment.utc(element.stream_info.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
              let expEndDate = endTime.format("Y-MM-DD");
              let eventEndTime = endTime.format('DD MMM YYYY');
              this.expDatesArr.push(expEndDate);
              if (moment(eventEndTime).isAfter(startTime)) {
                if (moment(eventEndTime).isAfter(startTime, 'year')) {
                  element.stream_info.startTime = localTime.format('DD MMM YYYY, hh:mm A');
                  element.stream_info.endTime = endTime.format('DD MMM YYYY, hh:mm A');
                  // element.stream_info.startTime = moment(localTime).format('DD MMM YYYY, hh:mm A');
                  // element.stream_info.endTime = moment(endTime).format('DD MMM YYYY, hh:mm A');
                } else {
                  element.stream_info.startTime = localTime.format('DD MMM, hh:mm A');
                  element.stream_info.endTime = endTime.format('DD MMM, hh:mm A');
                  // element.stream_info.startTime = moment(localTime).format('DD MMM, hh:mm A');
                  // element.stream_info.endTime = moment(endTime).format('DD MMM, hh:mm A');
                }
              } else {
                element.stream_info.startTime = localTime.format('hh:mm A');
                element.stream_info.endTime = endTime.format('hh:mm A');
                // element.stream_info.startTime = moment(localTime).format('hh:mm A');
                // element.stream_info.endTime = moment(endTime).format('hh:mm A');
              }
              if (element.stream_info.agenda && element.stream_info.agenda.length > 0) {
                element.stream_info.agenda.forEach(ag => {
                  let localTime = moment.utc(ag.start_time).toDate();
                  ag.start_time = moment(localTime).format('hh:mm A');
                  let localEndTime = moment.utc(ag.end_time).toDate();
                  ag.end_time = moment(localEndTime).format('hh:mm A');
                });
              }
            }
            if (element.guestList && element.guestList.length > 0) {
              element.guestList.forEach(guest => {
                guest.display_name = guest.first_name ? guest.first_name[0] : "";
                if (guest.last_name) {
                  guest.display_name += guest.last_name ? guest.last_name[0] : "";
                } else if (guest.first_name && guest.first_name[1]) {
                  guest.display_name += guest.first_name[1];
                }
                guest.userColor = this.getColor(guest);
                guest.shortName = this.getName(guest.display_name);
              });
              element.finalGuestsList = element.guestList.filter(e => e.reveal_to_audience == 1);
            }
            console.log("list ::", element.finalGuestsList);
          });
        }
        // if (this.streamInfo.event_dates_json) {
        this.streamInfo.event_dates_json = JSON.parse(this.streamInfo.event_dates_json);
        // this.datesList = [...this.streamInfo.event_dates_json];
        let datesArr = [];
        if (this.subEvents.length > 0) {
          this.subEvents.forEach(event => {
            // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
            // event.start = moment(eventDate).format('YYYY-MM-DD');
            // let eventEnd = moment.utc(event.stream_info.expected_end_date_time).toDate();
            // event.end = moment(eventEnd).format('YYYY-MM-DD');
            let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
            event.start = localTime.format('YYYY-MM-DD');
            event.filterDate = localTime.format("DD");
            let eventEnd = moment.utc(event.stream_info.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
            event.end = eventEnd.format('YYYY-MM-DD');
            datesArr.push(event);
          });
        }
        this.datesList = [...new Map(datesArr.map(item =>
          [item['start'], item])).values()];
        if (this.datesList && this.datesList.length > 0) {
          this.datesList.forEach((date, key) => {
            date.originalDate = date.start;
            date.startDates = moment(date.start).format("DD MMM") + " " + moment(date.start).format("YYYY");
            // date.startDates = moment(date.start).format("ddd") + ", " + moment(date.start).format("DD MMM") + " " + moment(date.start).format("YYYY");
            // date.start = moment(date.start).format("DD MMM");
            // date.day = moment(date.originalDate).format("ddd");
            date.start = moment(date.start).format("DD MMM");
            date.day = moment(date.originalDate).format("ddd");
            if (this.streamInfo.selected_type == 'single_day_event' || this.streamInfo.selected_type == 'multi_day_event' || this.streamInfo.stream_vod == 'vod') {
              if (key == 0)
                this.eventStartDate = moment(date.originalDate).format("ddd") + ", " + moment(date.originalDate).format("DD MMM") + " " + moment(date.originalDate).format("YYYY");
              this.eventEndDate = moment(date.end).format("ddd") + ", " + moment(date.end).format("DD MMM") + " " + moment(date.end).format("YYYY");
            }
          });
          if (this.selectedTabData >= 1) {
            this.selectedTabData = this.selectedDateIndex;
            this.onChangeDate(this.selectedTabEvent);
          } else {
            if (this.datesList && this.datesList.length > 0) {
              let event: any = {
                "index": 0,
                "tab": {
                  "textLabel": this.datesList[0].originalDate
                }
              }
              this.onChangeDate(event);
            }
          }
        }
        // }
        let isFromLink = false;
        if (this.route && this.route.snapshot && this.route.snapshot.fragment) {
          isFromLink = true;
        }
        if (isFromLink) {
          if (this.route.snapshot.fragment == 'tc') {
            setTimeout(() => {
              this.scrollTo('tc', 'TandCSection');
            }, 1000);
          } else if (this.route.snapshot.fragment == 'faq') {
            setTimeout(() => {
              this.scrollTo('faq', 'faqSection');
            }, 1000);
          }

        } else {
          if (this.streamInfo.stream_video_description != null && this.streamInfo.stream_video_description != '' && this.streamInfo.stream_video_description != 'null')
            this.selectedTab = 'overview';
          else if (this.subEvents && this.subEvents.length > 0 && this.streamInfo.selected_type != 'single_session_event')
            this.selectedTab = 'schedule';
          else if (this.guestList && this.guestList.length > 0)
            this.selectedTab = 'speaker';
          else
            this.selectedTab = 'host';
        }
        let moments = this.expDatesArr.map(d => moment(d))
        this.priceDetails = response['data']['Data']['price_details'] || {};
        this.nftPriceDetails = response['data']['Data']['nft_price_details']
        this.getMaxPrice();
        let maximumDate = (moment.max(moments));
        let maxEventDate = moment(maximumDate['_i']).format('Y-MM-DD');
        let CDateTime = moment.utc(new Date()).format('Y-MM-DD');
        let streamStatus = this.subEvents.filter(a => a.stream_status == 'completed');
        if (maxEventDate <= CDateTime && this.priceDetails.message && !this.priceDetails.message.includes('Ended') && !this.priceDetails.message.includes('ended') && !this.priceDetails.message.includes('Sold Out')) {
          if (this.subEvents && this.subEvents.length == 0)
            this.showMsg = 'Event ended. ';
          if (this.subEvents && this.subEvents.length == streamStatus.length)
            this.priceDetails.message = 'Recording ' + this.priceDetails.message;
          else
            this.priceDetails.message = this.priceDetails.message;
        }
        // this.checkIsUserSubscribe((IsUserSubscribe: any) => {
        let IsUserSubscribe;
        this.IsUserSubscribe = this.priceDetails ? this.priceDetails.subscription_status : false;
        this.ngxLoader.stop();
        this.streamInfo['allow_vod'] = (this.streamInfo['allow_vod'] && this.streamInfo['allow_vod'] == 1) ? true : true;
        let eventInfo = {
          "isEvent": this.streamInfo.stream_status == 'progress' ? 'live' : 'upcoming',
          "number_of_creators": this.streamInfo.number_of_creators,
          "channel_name": this.streamInfo.channel_name,
          "id": this.streamInfo.id,
          "slug": this.streamInfo.slug,
          "allow_vod": this.streamInfo.allow_vod,
          "ref_code": this.route.snapshot.queryParams && this.route.snapshot.queryParams.ref ? this.route.snapshot.queryParams.ref : '',
          "message": this.priceDetails && this.priceDetails.message ? this.priceDetails.message : ''
        }
        this.storageService.setItem("eventInfo", eventInfo);

        if (this.streamInfo.age_limit <= 15) {
          this.streamInfo.ageInfo = 'Family Friendly';
        } else if (this.streamInfo.age_limit == 16 || this.streamInfo.age_limit <= 17) {
          this.streamInfo.ageInfo = 'Adults Supervision';
        } else if (this.streamInfo.age_limit == 18 || this.streamInfo.age_limit <= 20) {
          this.streamInfo.ageInfo = '18+';
        } else if (this.streamInfo.age_limit == 21 || this.streamInfo.age_limit > 21) {
          this.streamInfo.ageInfo = '21+';
        }
        if (this.streamInfo) {
          let name = this.streamInfo.stream_video_title ? this.streamInfo.stream_video_title.split(' ') : "";
          if (name) {
            let secondName = name[1] ? name[1].charAt(0) : name[0].charAt(1);
            this.streamInfo.displayTitleName = name[0].charAt(0) + secondName;
          }
        }
        //   let localTime = moment.utc(this.streamInfo.publish_date_time).toDate();
        //   this.streamInfo.time = moment(localTime).format('hh:mm A');
        //   this.streamInfo.date = moment(localTime).format('ddd, MMM DD');
        //   ctDate = moment().format("YYYY-MM-DD");
        //   currentDate = new Date(ctDate).getTime();
        //   if (this.streamInfo.expected_end_date_time) {
        //     let endTime = moment.utc(this.streamInfo.expected_end_date_time).toDate();
        //     let eventEndDate = moment(endTime).format('YYYY-MM-DD');
        //     let expected_end_date_time = moment(endTime).format('hh:mm A');
        //     this.streamInfo.time += ' - ' + expected_end_date_time;
        //     let eventDate = new Date(eventEndDate).getTime();
        //     let currentMonth = moment(localTime).format('MMM')
        //     if (currentDate == eventDate) {
        //       this.streamInfo.date = moment(localTime).format('ddd, MMM DD YYYY');
        //     } else {
        //       let checkMonth = moment(endTime).format('MMM');
        //       if (checkMonth == currentMonth) {
        //         let end_date_time = moment(endTime).format('DD YYYY');
        //         let checkDate = this.streamInfo.date.split(' ');
        //         let endDate = end_date_time.split(' ');
        //         if (checkDate[2] == endDate[0])
        //           this.streamInfo.date = this.streamInfo.date +' ' + new Date().getFullYear();
        //         else
        //           this.streamInfo.date += ' - ' + end_date_time;
        //       }
        //       else {
        //         let end_date_time = moment(endTime).format('MMM DD YYYY');
        //         this.streamInfo.date += ' - ' + end_date_time;
        //       }
        //     }
        //   }
        //   var eventStartDates: any = [], eventEndDates: any = [], USDPrice = [], GBPPrice = [];
        if (this.streamInfo && this.streamInfo.stream_amounts)
          this.displayAmounts = this.streamInfo && this.streamInfo.stream_amounts ? JSON.parse(this.streamInfo.stream_amounts) : [];

        //   // if(!IsUserSubscribe) {
        //   //   this.displayAmounts.live_stream = this.displayAmounts.non_sub_live_stream;
        //   //   this.displayAmounts.vod = this.displayAmounts.non_sub_vod;
        //   // }
        //   if(IsUserSubscribe) {
        //     this.displayAmounts.live_stream = this.displayAmounts.sub_live_stream;
        //     this.displayAmounts.vod = this.displayAmounts.sub_vod;
        //   }
        if (IsUserSubscribe && this.displayAmounts && this.displayAmounts.subscriberPayment == "free") {
          this.streamInfo.stream_payment_mode = 'free';
        }
        // let enable_vod_setup = this.displayAmounts && this.displayAmounts.enable_vod_setup ? this.displayAmounts.enable_vod_setup : false;
        // let eventType = this.streamInfo.stream_vod == "stream" ? "stream" : "vod";
        // if (eventType == "stream" && this.streamInfo.stream_status == "completed") {
        //   eventType = "vod";
        // }
        // if (this.displayAmounts)
        //   this.displayAmounts = eventType == 'vod' ? this.displayAmounts.vod : this.displayAmounts.live_stream;
        if (this.streamInfo.stream_vod == 'vod' && this.priceDetails && this.priceDetails.min == 0 && this.priceDetails.max == 0) {
          this.streamInfo.stream_payment_mode = 'free';
        }
        this.ticketsData = response['data']['Data']['tickets'];
        let liveTickets = this.ticketsData.filter(a => a.live);
        if (this.ticketsData.length == liveTickets.length) {
          this.isLiveTickets = true;
        }
        if (response && response.data && response.data.Data && response.data.Data.user_subscription_info &&
          response.data.Data.user_subscription_info[0]) {
          if (response.data.Data.user_subscription_info[0].transaction_status == "Completed") {
            this.userSubscriptionInfo = response.data.Data.user_subscription_info[0];
            this.ticketsData.forEach(element => {
              if (element.add_ons)
                element.add_ons = typeof element.add_ons == 'string' ? JSON.parse(element.add_ons) : element.add_ons;
            });
            let addon = this.ticketsData.filter(a => a.add_ons && a.add_ons.length > 0);
            let filteredData;
            if (addon.length > 0) {
              addon.forEach(element => {
                if (this.userSubscriptionInfo && this.userSubscriptionInfo.ticketIDs.length > 0) {
                  if (element.add_ons && this.userSubscriptionInfo.ticketIDs.includes(element.id))
                    element.addOnCheck = true;
                  else
                    element.addOnCheck = false;
                }
              });
              filteredData = addon.filter(a => a.addOnCheck);
              if (filteredData.length == this.userSubscriptionInfo.ticketIDs.length)
                this.showHome = true;
              console.log('>>>>>>>>>>', this.showHome)
            }

            this.isUserRegistered = true;
            this.storageService.deleteItem('eventInfo');
            this.storageService.deleteItem('isEvent');
            // if (this.streamInfo.stream_status != 'completed') {
            //   this.goToStream();
            // } else {
            //   if (this.streamInfo['stream_status'] == 'completed' && this.streamInfo['conversion_status'] == "completed" && this.streamInfo['vod_urls'] != null && response.data.Data.user_subscription_info &&
            //     response.data.Data.user_subscription_info.length > 0 && this.streamInfo['allow_vod'])
            //     this.router.navigateByUrl(`watch/${this.streamInfo.id}`);
            //   else if (!this.streamInfo['allow_vod'])
            //     this.toastr.error('Video recording is not available');
            // }
          }
          if (this.subEvents && this.subEvents.length == 1) {
            if (ticketsInfo && ticketsInfo.length > 0) {
              ticketsInfo.forEach(element => {
                if (this.userSubscriptionInfo.ticketIDs && this.userSubscriptionInfo.ticketIDs.includes(element.id)) {
                  if (element.sessions && (element.sessions.includes(this.subEvents[0].streamid) || element.sessions.includes(this.streamInfo.id))) {
                    this.isRegistered = true;
                  }
                }
              });
            }
          }
        }
        //   this.displayAmounts = this.displayAmounts || [];
        //   this.displayAmounts.forEach(e => {
        //     let foundCurrency: any = "";
        //     e.amounts.forEach(ele => {
        //       if (this.currentLocation.country_name && this.currentLocation.currency && ele.currency_type && ele.country_name
        //         && ele.currency_type == this.currentLocation.currency.code && ele.country_name == this.currentLocation.country_name) {
        //         foundCurrency = ele;
        //       }
        //       if (foundCurrency) {
        //         if (foundCurrency.currency_type == 'USD')
        //           USDPrice.push(foundCurrency.stream_payment_amount);
        //         else if (foundCurrency.currency_type == 'GBP')
        //           GBPPrice.push(foundCurrency.stream_payment_amount);
        //       } else {
        //         if (ele.currency_type == 'USD' && ele.country_name == 'DEFAULT')
        //           USDPrice.push(ele.stream_payment_amount);
        //         else if (ele.currency_type == 'GBP' && ele.country_name == 'DEFAULT')
        //           GBPPrice.push(ele.stream_payment_amount);
        //       }
        //       var USDValues = USDPrice.sort((a, b) => {
        //         return a - b;
        //       });
        //       var GBPValues = GBPPrice.sort((a, b) => {
        //         return a - b;
        //       });
        //       this.currencyType = this.streamInfo.currency_type == 'USD' ? '$' : '£'
        //       if (this.streamInfo.currency_type == 'USD' && USDValues && USDValues.length > 0)
        //       this.streamInfo.price = USDValues.length >1 && (USDValues[0] != USDValues[USDValues.length - 1])? this.currencyType + USDValues[0] + ' - ' + this.currencyType + USDValues[USDValues.length - 1] : this.currencyType + USDValues[0];
        //       else
        //       this.streamInfo.price = GBPValues.length >1 && (GBPValues[0] != GBPValues[GBPValues.length - 1]) ?this.currencyType + GBPValues[0] + ' - ' + this.currencyType + GBPValues[GBPValues.length - 1] : this.currencyType + GBPValues[0];
        //     })
        //     if (e.booking_start_date) {
        //       let bookingStartTime = moment.utc(e.booking_start_date).toDate();
        //       // let startTime = moment(bookingStartTime).format('YYYY-MM-DD HH:mm');
        //       eventStartDates.push(new Date(bookingStartTime).getTime());
        //       let bookingEndTime = moment.utc(e.booking_end_date).toDate();
        //       // let EndTime = moment(bookingEndTime).format('YYYY-MM-DD HH:mm');
        //       eventEndDates.push(new Date(bookingEndTime).getTime());
        //     }
        //   });
        //     if(response && response.data && response.data.Data && response.data.Data.user_subscription_info &&
        //     response.data.Data.user_subscription_info[0])  {
        //     if(response.data.Data.user_subscription_info[0].transaction_status == "Completed"){
        //       this.isUserRegistered = true;
        //       this.storageService.deleteItem('eventInfo');
        //       if (this.streamInfo.stream_status != 'completed') {
        //         this.goToStream();
        //       } else {
        //         if (this.streamInfo['stream_status'] == 'completed' && this.streamInfo['conversion_status'] == "completed" && this.streamInfo['vod_urls'] != null && response.data.Data.user_subscription_info &&
        //           response.data.Data.user_subscription_info.length > 0)
        //           this.router.navigateByUrl(`watch/${this.streamInfo.id}`);
        //       }
        //     }
        //   }
        // }
        this.checkIsUserSubscribed = IsUserSubscribe;

        // if(this.streamInfo.stream_payment_mode == 'free')
        //   this.streamInfo.priceRange = this.commonSubscribeService.getAmount(this.streamInfo, this.currentLocation, IsUserSubscribe);
        this.streamInfo.IsUserSubscribe = IsUserSubscribe;
        this.commonSubscribeService.streamInfo = this.streamInfo;
        this.commonSubscribeService.sendStreamInfo(this.streamInfo);
        // if (this.streamInfo.stream_payment_mode == 'paid') {
        //   // this.streamInfo.stream_amounts = tempTicketType;
        //   this.streamInfo.priceRange = this.commonSubscribeService.getAmount(this.streamInfo, this.currentLocation, this.checkIsUserSubscribed, this.ticketsData);
        //   // console.log(result);


        //   if (this.streamInfo.priceRange.minPrice != this.streamInfo.priceRange.maxPrice) {
        //     this.streamInfo.showRange = true;
        //     this.streamInfo.price = this.streamInfo.priceRange.minCurrency + this.streamInfo.priceRange.minPrice + " - " + this.streamInfo.priceRange.maxCurrency + this.streamInfo.priceRange.maxPrice;
        //   } else {
        //     this.streamInfo.showRange = false;
        //     this.streamInfo.price = this.streamInfo.priceRange.minCurrency + this.streamInfo.priceRange.minPrice;
        //   }
        // }
        // let localTime = moment.utc(this.streamInfo.publish_date_time).toDate();
        // this.streamInfo.time = moment(localTime).format('hh:mm A');
        // this.streamInfo.date = moment(localTime).format('ddd, MMM DD');
        // ctDate = moment().format("YYYY-MM-DD");
        // currentDate = new Date(ctDate).getTime();
        // if (this.streamInfo.expected_end_date_time) {
        //   let endTime = moment.utc(this.streamInfo.expected_end_date_time).toDate();
        //   let eventEndDate = moment(endTime).format('YYYY-MM-DD');
        //   let expected_end_date_time = moment(endTime).format('hh:mm A');
        //   this.streamInfo.time += ' - ' + expected_end_date_time;
        //   let eventDate = new Date(eventEndDate).getTime();
        //   let currentMonth = moment(localTime).format('MMM')
        //   if (currentDate == eventDate) {
        //     this.streamInfo.date = moment(localTime).format('ddd, MMM DD YYYY');
        //   } else {
        //     let checkMonth = moment(endTime).format('MMM');
        //     if (checkMonth == currentMonth) {
        //       let end_date_time = moment(endTime).format('DD YYYY');
        //       let checkDate = this.streamInfo.date.split(' ');
        //       let endDate = end_date_time.split(' ');
        //       if (checkDate[2] == endDate[0])
        //         this.streamInfo.date = this.streamInfo.date +' ' + new Date().getFullYear();
        //       else
        //         this.streamInfo.date += ' - ' + end_date_time;
        //     }
        //     else {
        //       let end_date_time = moment(endTime).format('MMM DD YYYY');
        //       this.streamInfo.date += ' - ' + end_date_time;
        //     }
        //   }
        // }
        // var eventStartDates: any = [], eventEndDates: any = [], USDPrice = [], GBPPrice = [];
        // this.displayAmounts = this.streamInfo && this.streamInfo.stream_amounts ? JSON.parse(this.streamInfo.stream_amounts) : [];
        // let eventType = this.streamInfo.stream_vod == "stream" ? "stream" : "vod";
        // if (eventType == "stream" && this.streamInfo.stream_status == "completed") {
        //   eventType = "vod";
        // }
        // if (this.displayAmounts)
        //   this.displayAmounts = eventType == 'vod' ? this.displayAmounts.vod : this.displayAmounts.live_stream;

        // this.displayAmounts = this.displayAmounts || [];
        // this.displayAmounts.forEach(e => {
        //   let foundCurrency: any = "";
        //   e.amounts.forEach(ele => {
        //     if (this.currentLocation.country_name && this.currentLocation.currency && ele.currency_type && ele.country_name
        //       && ele.currency_type == this.currentLocation.currency.code && ele.country_name == this.currentLocation.country_name) {
        //       foundCurrency = ele;
        //     }
        //     if (foundCurrency) {
        //       if (foundCurrency.currency_type == 'USD')
        //         USDPrice.push(foundCurrency.stream_payment_amount);
        //       else if (foundCurrency.currency_type == 'GBP')
        //         GBPPrice.push(foundCurrency.stream_payment_amount);
        //     } else {
        //       if (ele.currency_type == 'USD' && ele.country_name == 'DEFAULT')
        //         USDPrice.push(ele.stream_payment_amount);
        //       else if (ele.currency_type == 'GBP' && ele.country_name == 'DEFAULT')
        //         GBPPrice.push(ele.stream_payment_amount);
        //     }
        //     var USDValues = USDPrice.sort((a, b) => {
        //       return a - b;
        //     });
        //     var GBPValues = GBPPrice.sort((a, b) => {
        //       return a - b;
        //     });
        //     this.currencyType = this.streamInfo.currency_type == 'USD' ? '$' : '£'
        //     if (this.streamInfo.currency_type == 'USD' && USDValues && USDValues.length > 0)
        //     this.streamInfo.price = USDValues.length >1 && (USDValues[0] != USDValues[USDValues.length - 1])? this.currencyType + USDValues[0] + ' - ' + this.currencyType + USDValues[USDValues.length - 1] : this.currencyType + USDValues[0];
        //     else
        //     this.streamInfo.price = GBPValues.length >1 && (GBPValues[0] != GBPValues[GBPValues.length - 1]) ?this.currencyType + GBPValues[0] + ' - ' + this.currencyType + GBPValues[GBPValues.length - 1] : this.currencyType + GBPValues[0];
        //   })
        //   if (e.booking_start_date) {
        //     let bookingStartTime = moment.utc(e.booking_start_date).toDate();
        //     // let startTime = moment(bookingStartTime).format('YYYY-MM-DD HH:mm');
        //     eventStartDates.push(new Date(bookingStartTime).getTime());
        //     let bookingEndTime = moment.utc(e.booking_end_date).toDate();
        //     // let EndTime = moment(bookingEndTime).format('YYYY-MM-DD HH:mm');
        //     eventEndDates.push(new Date(bookingEndTime).getTime());
        //   }
        // });
        // });

      } else {
        this.ngxLoader.stop();
        this.router.navigateByUrl('page-not-found/404');
      }
      this.showBlocks('init');

      // this.showBlocks('init');
      // var values = eventStartDates.sort((a, b) => {
      //   return a - b;
      // });
      // var endingValues = eventEndDates.sort((a, b) => {
      //   return a - b;
      // });
      // if (values[0] > currentDate) {
      //   this.startDate = moment(values[0]).format('DD MMM YYYY');
      //   this.saleStarts = true;
      // } else if (currentDate >= values[0] && currentDate <= endingValues[endingValues.length - 1]) {
      //   this.checkSale = true;
      // }
      // if (currentDate > endingValues[endingValues.length - 1])
      //   this.saleCompleted = true;
    }).catch(error => {
      this.eventRequestKey = null;
      this.ngxLoader.stop(EVENT_LOADER_TASK);
      this.ngxLoader.stop();
      // Only when nothing rendered - this catch also sees errors thrown while processing a successful response.
      if (!this.streamInfo?.slug) {
        this.toastr.error("Couldn't load event, please refresh the page");
      }
    });

  }
  eventDetails() {

    this.streamAds = this.streamInfo['stream_ads'];


    this.streamAdsData = [];
    if (this.streamAds && this.streamAds.length > 0) {

      this.streamAds.forEach(element => {
        this.streamAdsData.push(element);
      });

      console.log("850x150 Ads in this event :: ", this.streamAdsData);
      if (this.streamAdsData.length > 0) {
        this.getAds();
      }
    }

  }
  minMaxpriceDetails: any;
  getMaxPrice() {
    let prices: any = [];
    let currency = this.priceDetails?.currency;
    prices.push(this.priceDetails.min ? this.priceDetails.min : 0, this.priceDetails.max ? this.priceDetails.max : 0)
    this.commonSubscribeService.getCurrencyRates("USD", result => {
      this.USD_Rates = result;
      if (this.nftPriceDetails) {
        if (this.nftPriceDetails.min != 0) {
          prices.push((this.nftPriceDetails.min / environment.ONE_USD) * this.USD_Rates[currency])
        }
        if (this.nftPriceDetails.max != 0) {
          prices.push((this.nftPriceDetails.max / environment.ONE_USD) * this.USD_Rates[currency])
        }
      }
      if (this.priceDetails?.min == null || this.priceDetails?.max == null) {
        prices = prices.filter((price) => {
          return price != 0
        })
      }
      if (prices.length) {
        this.minMaxpriceDetails = {
          max: Math.max(...prices),
          min: Math.min(...prices),
          currency: currency
        }
        console.log(this.minMaxpriceDetails, "minmaxpricedetails")
      }

    })


  }
  showDesc: boolean = false;
  displayDesc() {
    this.showDesc = !this.showDesc;
  }

  groupSponsorsByType() {
    this.sponsorsInfo = this.sponsorsInfo.sort((a, b) => a.sponsorship_order > b.sponsorship_order ? 1 : -1);
    //  const sorted = stages.sort((a, b) => a.sessionDate > b.sessionDate ? 1 : -1);
    const grouped = this.sponsorsInfo.reduce((groups, sponsor) => {
      const pos = sponsor.sponsorship_type;
      groups[pos] = groups[pos] || [];
      groups[pos].push(sponsor);

      return groups;
    }, {});

    this.sponsorsInfo = Object.keys(grouped).map(key => ({ sponsorship_type: key, sponsors: grouped[key] }));
  }
  selectedAdData: any;
  async getAds() {
    let AdsDetails = [];
    let allDiv = [];
    let count = 0;

    var temp_site_id = null;
    this.preloadAdsdata = [];
    if (this.streamAdsData && this.streamAdsData.length > 0) {
      console.log("LIST_ADS result :: ", this.streamAdsData);
      this.sponsorData = this.streamAdsData;
      //////////////////////////////
      var j = 0;
      var i = 1;

      var adTypeIdarr = [];
      var placements = [];
      this.streamAdsData.forEach(el => {
        temp_site_id = Number(el.site_id)
        // if(this.siteId && this.siteId == el.site_id){
        // temp_site_id = Number(el.site_id)
        // }
        j += 1;
        adTypeIdarr.push(el.adTypeId);
        placements.push({
          "divName": "div" + i + j,
          "networkId": Number(environment.kevel.NETWORK_ID),
          // "siteId": (this.siteId == el.site_id) ? Number(el.site_id) : null,
          "siteId": Number(el.site_id),
          "adTypes": [el.adTypeId],
          "campaignId": Number(el.campaignId),
          "flightId": Number(el.flight_id),
          "adId": Number(el.ad_id)
        });
        allDiv.push("div" + i + j);
        count = count + 1;
        if (this.streamAdsData.length == count) {
          // AdsDetails.push({
          //   "networkId": Number(environment.kevel.NETWORK_ID),
          //   "siteId": temp_site_id,
          //   "placement_data": placements,
          // });
          console.log("AdsDetails ==> ", AdsDetails);
          let data = {
            // "placements": AdsDetails.length > 0 ? AdsDetails : null,
            "placements": placements,
            "allDiv": allDiv
            // "allDetails":JSON.stringify(AdsDetails)
          };
          if (temp_site_id) {
            this.eventHomeAdsTop = [];
            this.eventHomeAdsRight = [];
            this.streamingPageAdsRight = [];
            this.streamingPageAdsTop = [];
            this.commonSubscribeService.getAdsData(data, (err, result) => {
              console.log("adsData ::", result)
              this.preloadAdsdata = result.Ads_data;
              if (this.preloadAdsdata.length > 0) {
                let durationArr = [];
                this.preloadAdsdata.forEach(element => {
                  console.log("element :::::::::::::: ", element);
                  this.selectedAdData = element.clickUrl;
                  console.log('eventHomeAdsRight selectedAdData :: ', this.selectedAdData);
                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 850 && element.height == 150) {
                    let adType = element.contents[0];
                    let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    console.log("customData :::::::::::::: ", customData);
                    // durationArr.push(adType['data']['customData']['maxPlayTime']);

                    let duration = adType['data']['customData']['maxPlayTime'];
                    this.adVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    console.log("adVideo :::::::::::::: ", this.adVideo);
                    this.eventHomeAdsTop.push({ 'image': this.adVideo, 'duration': (duration * 1000) });
                    if (element.impressionUrl) {
                      this.commonSubscribeService.countAdsImpressions(element.impressionUrl);
                    }
                  }

                  if (element.contents && element.contents[0] && element.contents[0].body && element.width == 400 && element.height == 400) {
                    let adType = element.contents[0];
                    let customData = adType.data['customData'] ? adType.data['customData'] : {};
                    let duration = adType['data']['customData']['maxPlayTime'];
                    let rightsadVideo = this.sanitizer.bypassSecurityTrustHtml(adType.body);
                    this.eventHomeAdsRight.push({ 'image': rightsadVideo, 'duration': (duration * 1000) });
                    // this.selectedAdData = data[this.duration].image;
                    // console.log('eventHomeAdsRight selectedAdData :: ', this.selectedAdData);
                    if (element.impressionUrl) {
                      this.commonSubscribeService.countAdsImpressions(element.impressionUrl);
                    }

                  }
                });
                console.log('durationArray', durationArr);
                console.log('FROM LOAD PAGE', this.eventHomeAdsRight);
                durationArr.sort((a, b) => {
                  return a - b;
                });
                this.duration = durationArr[durationArr.length - 1];
                console.log("durationHighestValue :::::::::::::: ", this.duration);
                console.log("durationValues :::::::::::::: ", durationArr);
                console.log('eventHomeAdsTop :: ', this.eventHomeAdsTop);
                console.log('eventHomeAdsRight :: ', this.eventHomeAdsRight);
                console.log('eventHomeAdsRight-length :: ', this.eventHomeAdsRight.length);
                setTimeout(() => {
                  this.loadAdsScript();
                }, 200);
              }

            });
          }
        }
      });
    }
  }
  scrollTo(tab, section) {
    this.selectedTab = tab;
    document.getElementById(section).scrollIntoView({ behavior: 'smooth' });
  }

  // scrollToDiv(currentSection, scrollTo) {
  //   this.selectedTab = scrollTo;
  //   $("#" + currentSection).click(function () {
  //     $('html, body').animate({
  //       scrollTop: $("#" + scrollTo).offset().top - 100
  //     }, 1500);
  //   });
  // }

  showGuestData: boolean = false;
  guestData = [];
  showGuestInfo(guest) {
    if (!this.showGuestData && guest.about_guest) {
      // this.guestData = this.guestList;
      this.finalGuestsList = [];
      this.showGuestData = true;
      this.finalGuestsList.push(guest);
      // this.guestList.push(guest);
    }
  }

  closeGuestInfo() {
    this.finalGuestsList = this.tempGuestList;
    this.showGuestData = false;
  }

  onChangeDate(event) {
    this.agendaGuestsData = [];
    if (event && event.tab && event.tab.textLabel) {
      this.selectedTabEvent = event;
      this.selectedDateIndex = event.index;
      this.selectedDate = moment(event.tab.textLabel).format("YYYY-MM-DD");
      if (this.subEvents && this.subEvents.length > 0) {
        this.subEvents.forEach(event => {
          event.finalGuestsList = [];
          // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
          // let s = moment(eventDate).format('YYYY-MM-DD');
          let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
          let s = localTime.format("YYYY-MM-DD");
          if (s == this.selectedDate) {
            event.isMatched = true;
            if (event.stream_info.agenda && event.stream_info.agenda.length > 0) {
              event.stream_info.agenda.forEach(ag => {
                if (ag.guest_ids && ag.guest_ids.length > 0) {
                  ag.guestList = [];
                  ag.guest_ids.forEach(guestid => {
                    if (event.guestList && event.guestList.length > 0) {
                      event.guestList.forEach(guest => {
                        if (guest.id == Number(guestid)) {
                          if (guest.first_name) {
                            guest.display_name = guest.first_name[0];
                            if (guest.last_name) {
                              guest.display_name += guest.last_name[0];
                            } else if (guest.first_name[1]) {
                              guest.display_name += guest.first_name[1];
                            }
                            guest.userColor = this.getColor(guest);
                            guest.shortName = this.getName(guest.display_name);
                          }
                          ag.guestList.push(guest);
                          if (guest.reveal_to_audience == 1) {
                            event.finalGuestsList.push(guest);
                          }
                        }
                      });
                    }
                  });
                }
              });
            }

          } else {
            event.isMatched = false;
          }
        });
      }
    }
  }

  changeDate(selectedDate) {
    this.selectedDate = selectedDate.start;
    if (this.subEvents && this.subEvents.length > 0) {
      this.subEvents.forEach(event => {
        // event.stream_info.publish_date_time is still the raw bare-UTC value here (unlike
        // this.streamInfo, sub-events don't get it overwritten) - parse as UTC before
        // formatting, same as the date tabs themselves (built via .utc(...).tz(...) above),
        // otherwise this comparison silently drifted a day off the calendar the tab shows.
        let eventDate = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
        let s = eventDate.format("ddd") + ", " + eventDate.format("DD MMM") + ", " + eventDate.format("YYYY");
        if (s == this.selectedDate) {
          event.isMatched = true;
        } else {
          event.isMatched = false;
        }
      });
    }
  }

  // getTicketsByEventId() {
  //   let data = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       "x-api-key": environment.AWS_Cognito.X_Api_Key,
  //       "Authorization": `Bearer ${this.userInfo.access_token}`
  //     },
  //     response: true,
  //     body: {}
  //   }
  //   let url = CONST_AWS_API.GET_TICKETS_BY_EVENT_ID + '/' + this.streamInfo.id + '/' + new Date().getTimezoneOffset()
  //   AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
  //     console.log('sdasd', response);
  //     if (response.status == 200) {
  //       this.ticketsData = response['data']['Data'];
  //       if (this.streamInfo.stream_payment_mode == 'paid') {
  //         // this.streamInfo.stream_amounts = tempTicketType;
  //         this.streamInfo.priceRange = this.commonSubscribeService.getAmount(this.streamInfo, this.currentLocation, this.checkIsUserSubscribed, this.ticketsData);
  //         // console.log(result);


  //         if (this.streamInfo.priceRange.minPrice != this.streamInfo.priceRange.maxPrice) {
  //           this.streamInfo.showRange = true;
  //           this.streamInfo.price = this.streamInfo.priceRange.minCurrency + this.streamInfo.priceRange.minPrice + " - " + this.streamInfo.priceRange.maxCurrency + this.streamInfo.priceRange.maxPrice;
  //         } else {
  //           this.streamInfo.showRange = false;
  //           this.streamInfo.price = this.streamInfo.priceRange.minCurrency + this.streamInfo.priceRange.minPrice;
  //         }
  //       }
  //     }
  //   }, error => {
  //     console.log(error);
  //   })
  // }

  toggleShow() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Share Event-Clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "Share Event - Clicked",
        timeStamp: new Date().toISOString(),
        eventId: this.streamInfo.id,
        eventName: this.streamInfo.stream_video_title,
        orgId: this.streamInfo.organization_id
        
      },
      organizationId: this.streamInfo.organization_id || null,
      networkGroupId: this.streamInfo.network_group_id || null,
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    this.isShown = !this.isShown;
  }
  shareClose() {
    this.isShown = false;
  }
  selectedTab: string = '';
  // getSelectedTab(tabName) {
  //   this.selectedTab = tabName;
  // }

  getName(name) {
    let returnString = "";
    if (name) {
      let a = name.split(" ");
      if (a.length > 1) {
        returnString = a[0].charAt(0);
        returnString += a[1].charAt(0);
        return returnString;
      } else if (name) {
        returnString = a[0].charAt(0);
        returnString += a[0].charAt(1);
        return returnString;
      } else {
        return returnString;
      }
    }
  }

  getColor(message) {
    let color = "";
    if (!this.userColor[message.id]) {
      color = COLORLIST[this.countUserColor];
      this.userColor[message.id] = COLORLIST[this.countUserColor];
      if (this.countUserColor > COLORLIST.length) {
        this.countUserColor = 0;
      } else {
        this.countUserColor++;
      }
    } else {
      color = this.userColor[message.id];
    }
    return color;
  }

  IsUserSubscribe = false;
  // checkIsUserSubscribe(callback: (val: any) => void) {

  //   this.getSubscriptionList((isFoundSubscriptionsPlan: any) => {
  //     if (!isFoundSubscriptionsPlan) {
  //       callback(false);
  //     } else {
  //       if (!this.userInfo || Object.keys(this.userInfo)?.length == 0) {
  //         this.IsUserSubscribe = false;
  //         callback(false);
  //       } else {
  //         let reqData = {
  //           headers: {
  //             "Content-Type": "application/json",
  //             "x-api-key": environment.AWS_Cognito.X_Api_Key,
  //             "Authorization": `Bearer ${this.userInfo.access_token}`
  //           },
  //           response: true,
  //           body: {
  //             user_id: this.userId,
  //             channel_url: this.streamInfo.channel_name
  //           }
  //         }
  //         AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_SUBSCRIPTION_STATUS, reqData).then(response => {
  //           if (response.data.message === "Success") {
  //             if (response.data && response.data.Data && response.data.Data.length > 0) {
  //               if (response.data.Data[0].subscription_status == 0) {
  //                 if (new Date().getTime() < new Date(response.data.Data[0].subscription_end_date).getTime()) {
  //                   this.IsUserSubscribe = true;
  //                 } else {
  //                   this.IsUserSubscribe = false;
  //                 }
  //               } else {
  //                 this.IsUserSubscribe = true;
  //               }
  //             } else {
  //               this.IsUserSubscribe = false;
  //             }
  //             callback(this.IsUserSubscribe);
  //           } else {
  //             this.IsUserSubscribe = false;
  //             callback(this.IsUserSubscribe);
  //           }
  //         }).catch(error => {
  //           this.ngxLoader.stop();
  //           // callback("fail");
  //           callback(false);
  //         });
  //       }
  //     }
  //   });
  // }

  isFoundSubscriptionsPlan = false;
  getSubscriptionList() {
    let reqData = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        channel_name: this.streamInfo.channel_name,
        user_id: this.userId,
        channel_url: this.streamInfo.channel_name
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_CHANNEL_SUBSCRIPTION_PLANS, reqData).then(response => {
      if (response.data.message === "Success") {
        if (response.data.Data && response.data.Data[0] && response.data.Data[0].plans && response.data.Data[0].plans.subscriptionsData) {
          let subscriptionList = response.data.Data[0].plans.subscriptionsData || [];
          if (subscriptionList && subscriptionList.length > 0) {
            this.isFoundSubscriptionsPlan = true;
          } else {
            this.isFoundSubscriptionsPlan = false;
          }
        } else {
          this.isFoundSubscriptionsPlan = false;
        }
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });
  }
  // getSubscriptionList(callback: (val: any) => void) {
  //   let reqData = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       "x-api-key": environment.AWS_Cognito.X_Api_Key,
  //       "Authorization": `Bearer ${this.userInfo.access_token}`
  //     },
  //     response: true,
  //     body: {
  //       channel_name: this.streamInfo.channel_name,
  //       user_id: this.userId,
  //       channel_url: this.streamInfo.channel_name
  //     }
  //   }
  //   AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_CHANNEL_SUBSCRIPTION_PLANS, reqData).then(response => {
  //     if (response.data.message === "Success") {
  //       if (response.data.Data && response.data.Data[0] && response.data.Data[0].plans && response.data.Data[0].plans.subscriptionsData) {
  //         let subscriptionList = response.data.Data[0].plans.subscriptionsData || [];
  //         if (subscriptionList && subscriptionList.length > 0) {
  //           this.isFoundSubscriptionsPlan = true;
  //           callback(true);
  //         } else {
  //           callback(false);
  //         }
  //       } else {
  //         callback(false);
  //       }
  //     }
  //   }).catch(error => {
  //     this.ngxLoader.stop();
  //     callback(false);
  //   });
  // }

  checkAge(callback) {
    let age_limit = parseInt(this.streamInfo.age_limit);
    let status = 'confirm';
    if (!isNaN(age_limit)) {
      if (age_limit <= 15) {
        status = 'yes';
      } else if (this.userInfo && this.userInfo.date_of_birth) {
        let age = new Date().getFullYear() - new Date(this.userInfo.date_of_birth).getFullYear();
        if (age_limit <= age) {
          status = 'yes';
        } else {
          status = 'no';
        }
      }
    } else {
      status = 'yes';
    }

    if (status == 'confirm' || status == 'no') {
      let msg = this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status == 'completed' ? 'vod' : 'event';
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'app-signout-confirmation',
        disableClose: true,
        data: {
          title: "This " + msg + " is intended for persons " + age_limit + " years or older. I agree that my age is " + age_limit + " or above.",
          eventId: this.streamInfo.id,
          eventName: this.streamInfo.stream_video_title,
          orgId: this.streamInfo.organization_id,
          settingsData:this.settingsData ? this.settingsData : null
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result === 'yes') this.commonSubscribeService.saveDateOfBirth(age_limit,this.streamInfo.organization_id);
        callback(result);
      });
    } else {
      callback(status);
    }
  }

  // Free-event Register buttons: logged-in users register in one click ("Remind Me",
  // specs/ai-agent-home-redesign US-21); guests keep the place-order form.
  get registerLabel(): string {
    return this.userInfo?.id ? 'Remind Me' : 'Register';
  }

  // fallback = the button's original action, used for guests and for events that need the form
  // (no free ticket, mandatory questions, shipping or add-ons).
  remindMe(fallback: 'tickets' | 'placeOrder') {
    const original = () => (fallback === 'tickets' ? this.getTickets() : this.goToPlaceOrder());
    if (!this.userInfo?.id) return original();
    if (this.isRemindMeBusy) return;
    this.checkAge(async (status) => {
      // Same outcomes as getTickets() for a declined age check / missing recording, without asking again.
      if (status != 'yes') {
        const msg = this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status == 'completed' ? 'vod' : 'event';
        return this.toastr.info('This ' + msg + ' may be inappropriate for some users');
      }
      if (this.streamInfo.stream_status == 'completed' && !this.streamInfo.allow_vod) return this.toastr.error('Video recording is not available');
      this.isRemindMeBusy = true;
      this.ngxLoader.start();
      try {
        const result = await this.quickRegister.register(this.route.snapshot.params.slug_name, this.userInfo, this.streamInfo.network_group_id);
        if (result.status === 'needs-form') {
          this.ngxLoader.stop();
          this.isRemindMeBusy = false;
          return original();
        }
        this.toastr.success(`You're registered for ${this.streamInfo.stream_video_title || 'this event'}`);
        this.ngxLoader.stop();
        this.isRemindMeBusy = false;
        this.refreshEventDetails();
      } catch (error) {
        this.ngxLoader.stop();
        this.isRemindMeBusy = false;
        this.toastr.error(error?.message || 'Could not register, please try again');
      }
    });
  }

  // Re-loads the event (getEventBySlug) so the buttons show the registered state without an app
  // reload. Clears the request cache that skips an identical, already-loaded request.
  refreshEventDetails() {
    this.eventRequestKey = null;
    this.lastLoadedEventKey = null;
    this.getEventDetails();
  }

  goToPlaceOrder() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Buy Tickets Clicked - ${userId}`)
    const u_payload = {
      actionType: "event",
      metaData: {
        title: `Buy Tickets Clicked`,
        timeStamp: new Date().toISOString(),
        eventId: this.streamInfo.id,
        eventName: this.streamInfo.stream_video_title,
        orgId: this.streamInfo.organization_id

      },
      organizationId: this.streamInfo.organization_id || null,
      networkGroupId: this.streamInfo.network_group_id || null,
      clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    try { fbq('track', 'Lead'); } catch (e) { }
    this.router.navigate([this.commonSubscribeService.getChannelBasePath(this.channelName) + `/event/${this.route.snapshot.params.slug_name}/place-order/${this.route.snapshot.params.ticket_key}`]);
  }

  getTickets() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Buy Tickets-Clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: "Buy Tickets - Clicked",
        timeStamp: new Date().toISOString(),
        eventId: this.streamInfo.id,
        eventName: this.streamInfo.stream_video_title,
        orgId: this.streamInfo.organization_id
      },
      organizationId: this.streamInfo.organization_id || null,
      networkGroupId: this.streamInfo.network_group_id || null,

    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    // if (this.userInfo && this.userInfo.id) {
    this.streamInfo.displayAmounts = this.displayAmounts;
    // this.storageService.setItem("streamInfo", this.streamInfo);
    this.commonSubscribeService.streamInfo = this.streamInfo;
    this.commonSubscribeService.sendStreamInfo(this.streamInfo);
    this.streamInfo['allow_vod'] = (this.streamInfo['allow_vod'] && this.streamInfo['allow_vod'] == 1) ? true : true;
    const channelName = this.router.url.split("/")[1];
    const channelBase = this.commonSubscribeService.getChannelBasePath(channelName);
    this.checkAge((status) => {
      if (status == 'yes' && this.streamInfo.stream_status != 'completed') {
        if (Object.keys(this.route.snapshot.queryParams).length > 0)
          this.router.navigate([channelBase + '/event/' + this.route.snapshot.params.slug_name + '/place-order'], { queryParams: { ref: this.route.snapshot.queryParams.ref } });
        else
          this.router.navigate([channelBase + `/event/${this.route.snapshot.params.slug_name}/place-order`]);
      } else if (status == 'yes' && this.streamInfo.stream_status == 'completed' && this.streamInfo.allow_vod) {
        if (Object.keys(this.route.snapshot.queryParams).length > 0)
          this.router.navigate([channelBase + '/event/' + this.route.snapshot.params.slug_name + '/place-order'], { queryParams: { ref: this.route.snapshot.queryParams.ref } });
        else
          this.router.navigate([channelBase + `/event/${this.route.snapshot.params.slug_name}/place-order`]);
      } else if (status == 'yes' && this.streamInfo.stream_status == 'completed' && !this.streamInfo.allow_vod) {
        this.toastr.error('Video recording is not available');
      } else {
        let msg = this.subEvents && this.subEvents.length == 1 && this.subEvents[0].stream_status == 'completed' ? 'vod' : 'event';
        this.toastr.info('This ' + msg + ' may be inappropriate for some users');
      }
    });
    // let age = new Date().getFullYear() - new Date(this.userInfo.date_of_birth).getFullYear();
    // if ((this.streamInfo.age_limit <= age || this.streamInfo.age_limit == 0) && this.streamInfo.stream_status!='completed') {
    //   this.router.navigateByUrl(`event/${this.route.snapshot.params.slug_name}/place-order`);
    // }else if((this.streamInfo.age_limit <= age || this.streamInfo.age_limit == 0) && this.streamInfo.stream_status=='completed' && this.streamInfo.allow_vod){
    //   this.router.navigateByUrl(`event/${this.route.snapshot.params.slug_name}/place-order`);
    // }else if((this.streamInfo.age_limit <= age || this.streamInfo.age_limit == 0) && this.streamInfo.stream_status=='completed' && !this.streamInfo.allow_vod){
    //   this.toastr.error('Video recording is not available');
    // } else {
    //   this.toastr.info('This video may be inappropriate for some users');
    // }
    // } else {
    // let eventInfo = {
    //   "isEvent":this.streamInfo.stream_status == 'progress'?'live':'upcoming',
    //   "number_of_creators" : this.streamInfo.number_of_creators,
    //   "channel_name": this.streamInfo.channel_name,
    //   "id":this.streamInfo.id,
    //   "slug":this.streamInfo.slug
    // }
    // this.storageService.setItem("eventInfo", eventInfo);
    // this.router.navigateByUrl("signup");
    //   this.landingPageService.openConsumerSignIn();
    // }
  }

  goToHome() {
    if (this.userInfo && this.userInfo.id) {
      this.router.navigateByUrl('/' + this.router.url.split('/')[1]);
    } else {
      this.router.navigateByUrl('/');
    }
  }

  goToStream() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Go To Stream button clicked - ${userId}`)
    const u_payload = {
      actionType: "event",
      metaData: {
        title: `Go To Stream button clicked`,
        timeStamp: new Date().toISOString(),
        eventId: this.streamInfo.id,
        eventName: this.streamInfo.stream_video_title,
        orgId: this.streamInfo.organization_id
      },
      organizationId: this.streamInfo.organization_id || null,
      networkGroupId: this.streamInfo.network_group_id || null,

      clickAction: `EVENT_JOINED`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    // let device = this.commonSubscribeService.getMobileOperatingSystem();
    // this.commonSubscribeService.sendDeviceType(device);
    this.commonSubscribeService.sendScreenStatus(false);
    // if(this.streamInfo && this.streamInfo.number_of_creators == 1)
    // if (!this.userSubscriptionInfo.hasOwnProperty('ticket_ids'))
    //   this.router.navigateByUrl(`stream/${this.userSubscriptionInfo.ticket_key}`);
    // else
    let key = this.route.snapshot.params.ticket_key ? this.route.snapshot.params.ticket_key : this.userSubscriptionInfo.ticket_key;
    const channelName = this.router.url.split('/')[1];
    const segment2 = this.router.url.split('/')[2];
    const groupSlug = segment2 && !['event', 'channel', 'stream', 'album', 'subscription-list'].includes(segment2) ? segment2 : '';
    const base = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
    if ((this.subEvents && this.subEvents.length > 1))
      this.router.navigate([`${base}/event/schedule/` + key]);
    else
      this.router.navigate([`${base}/stream/` + key], { queryParams: { stage: this.subEvents[0].streamid } });
    // else
    //   this.router.navigateByUrl(`group-stream/${this.streamInfo.id}`);
  }

  goToVOD() {
    let device = this.commonSubscribeService.getMobileOperatingSystem();
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Go To VOD button clicked - ${userId}`)
    const u_payload = {
      actionType: "event",
      metaData: {
        title: `Go To VOD button clicked`,
        timeStamp: new Date().toISOString(),
        eventId: this.streamInfo.id,
        eventName: this.streamInfo.stream_video_title,
        orgId: this.streamInfo.organization_id
      },
      organizationId: this.streamInfo.organization_id || null,
      networkGroupId: this.streamInfo.network_group_id || null,

      clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    this.commonSubscribeService.sendDeviceType(device);
    this.commonSubscribeService.sendScreenStatus(false);
    if (this.streamInfo['allow_vod']) {
      const channelName = this.router.url.split('/')[1];
      const segment2 = this.router.url.split('/')[2];
      const groupSlug = segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(segment2) ? segment2 : '';
      const base = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
      if ((this.subEvents && this.subEvents.length > 1))
        this.router.navigate([`${base}/event/schedule/` + this.route.snapshot.params.ticket_key]);
      else
        this.router.navigate([`${base}/watch/` + this.userSubscriptionInfo.ticket_key], { queryParams: { stage: this.subEvents[0].streamid } });
    }
    else if (!this.streamInfo['allow_vod'])
      this.toastr.error('Video recording is not available');
  }

  goToSubscribe() {
    if (this.userInfo && this.userInfo.id) {
      this.router.navigate([`/c/${this.streamInfo.channel_name}/subscription-list`], { queryParams: { returnUrl: `/event/${this.route.snapshot.params.slug_name}` } });
    } else {
      this.commonSubscribeService.returnUrl = `/c/${this.streamInfo.channel_name}/subscription-list?returnUrl=/event/${this.route.snapshot.params.slug_name}`;
      this.storageService.setItem("isSubscribed", this.streamInfo.channel_name);
      this.landingPageService.openConsumerSignIn();
    }
  }

  backClicked() {
    this.location.back();
  }

  getExpoList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXPO_LIST + '/' + this.streamInfo.id;
    this.ngxLoader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.ngxLoader.stop();
        this.expoInfo = response.data.Data;
      }
    }).catch(error => {
      this.ngxLoader.stop();
    });

  }

  imInterested() {
    this.imInterestedClick = !this.imInterestedClick
  }

  openVideoDialog(sponsor) {
    let data = {
      sponsorInfo: sponsor
    }
    const dialogRef = this.dialog.open(SponsorVideoDialog, {
      panelClass: 'sponsor-video-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  ngOnDestroy() {
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.currencyInfoSubscription)
      this.currencyInfoSubscription.unsubscribe();
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    this.storageService.deleteItem('isSubscribed');
    this.storageService.deleteItem('subscriptionChannelName');
    this.unsubscriber.next();
    this.unsubscriber.complete();
    if (this.ticketPanelResizeObserver) {
      this.ticketPanelResizeObserver.disconnect();
    }
  }

  ngAfterViewInit(): void {
    this.tryAttachTicketPanelObserver();
  }

  ngAfterViewChecked(): void {
    // .party-ticket only exists once priceDetails resolves (*ngIf="priceDetails"),
    // which is set asynchronously from an API response well after
    // ngAfterViewInit runs — so the observer must be attached lazily, once the
    // element actually appears, not just on the first view init.
    this.tryAttachTicketPanelObserver();
  }

  private tryAttachTicketPanelObserver(): void {
    // .party-ticket floats over the banner via position: absolute, so its
    // height never affects layout below it. Watching its size (it changes as
    // streamInfo/settingsData load in, e.g. the Matchup block appearing) lets
    // us reserve exactly enough space via ticketPanelOverflowPx instead of
    // letting it overlap the content that follows.
    if (this.ticketPanelResizeObserver || typeof ResizeObserver === 'undefined' || !this.partyTicketPanelRef) {
      return;
    }
    this.ticketPanelResizeObserver = new ResizeObserver(() => this.recomputeTicketPanelOverflow());
    this.ticketPanelResizeObserver.observe(this.partyTicketPanelRef.nativeElement);
  }

  private setThemeCssVar(name: string, value: string): void {
    if (value) {
      document.documentElement.style.setProperty(name, value);
    } else {
      document.documentElement.style.removeProperty(name);
    }
  }

  // When the org/group hasn't configured one, the property must stay UNSET (not force a
  // hardcoded fallback here) so consumers' own `var(--x, fallback)` can fall back to their
  // original static color — forcing a value here previously made e.g. the wallet icon render
  // as a near-invisible rgba(0,0,0,0.12) fill whenever event_font_primary_color was empty,
  // instead of keeping its original visible color.
  private applyThemeCssVars(): void {
    this.setThemeCssVar('--event-border-color', this.settingsData?.['event_card_font_color']);
    this.setThemeCssVar('--event-font-primary-color', this.settingsData?.['event_font_primary_color']);
  }

  private recomputeTicketPanelOverflow(): void {
    const overdivEl = this.ticketOverdivRef?.nativeElement;
    const panelEl = this.partyTicketPanelRef?.nativeElement;
    if (!overdivEl || !panelEl) {
      return;
    }
    const overflowPx = Math.max(0, panelEl.getBoundingClientRect().bottom - overdivEl.getBoundingClientRect().bottom);
    if (Math.round(overflowPx) !== Math.round(this.ticketPanelOverflowPx)) {
      this.zone.run(() => this.ticketPanelOverflowPx = overflowPx);
    }
  }

}

@Component({
  selector: 'app-sponsor-video-dialog',
  templateUrl: './sponsor-video-dialog.html',
  styleUrls: ['./event-details.component.scss']
})
export class SponsorVideoDialog {
  sponsorInfo: any;
  constructor(private router: Router,
    public dialogRef: MatDialogRef<SponsorVideoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
    this.sponsorInfo = data.sponsorInfo;
  }
  goToHome(): void {
    this.dialogRef.close();
  }

}